import { TypedDocumentNode, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import { EditTicketMutation as EditTicket, EditTicketInput } from '__generated__/graphql';
import { useNotifier } from '../../../../common/Notifications/NotificationProvider';
import EditTicketMutation from './EditTicketMutation';
import useScroll from '../../../../common/useScroll';

interface UseEditTicketMutationProps {
  input: EditTicketInput,
  onSuccess?: (ticket: EditTicket['editTicket']) => void;
  refetchQueries?: TypedDocumentNode[];
}

const useEditTicketMutation = ({ input, onSuccess, refetchQueries }: UseEditTicketMutationProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();
  const { scrollToIfInvisible } = useScroll();

  return useMutation(EditTicketMutation, {
    variables: {
      input,
    },
    onCompleted: ({ editTicket: ticket }) => {
      notifier.success(t('notifications.ticket_saved'));

      onSuccess?.(ticket);
    },
    onError: () => {
      scrollToIfInvisible(`TicketCard_${input.id}`);
    },
    refetchQueries,
  });
};

export default useEditTicketMutation;
